import React from "react";
import { Route } from "react-router-dom";
import { CanAccessThisPage } from "Common/RoleVerify";

import MyProfile from "Partials/MyProfile/MyProfile";
import AddPositions from "HRMS/Positions/AddPositions/AddPositions";
import EditPositions from "HRMS/Positions/EditPositions/EditPositions";
import AddDepartment from "HRMS/Department/AddDepartment/AddDepartment";
import EditDepartment from "HRMS/Department/EditDepartment/EditDepartment";
import AddDivision from "HRMS/Division/AddDivision/AddDivision";
import EditDivision from "HRMS/Division/EditDivision/EditDivision";
import AddRecruitment from "HRMS/Recruitment/CandidateRecruitment/AddRecruitment/AddRecruitment";
import EditRecruitment from "HRMS/Recruitment/CandidateRecruitment/EditRecruitment/EditRecruitment"
import AddCandidateShortlist from "HRMS/Recruitment/CandidateShortlist/AddCandidateShortlist/AddCandidateShortlist";
import EditCandidateShortlist from "HRMS/Recruitment/CandidateShortlist/EditCandidateShortlist/EditCandidateShortlist";
import AddCandidateInterview from "HRMS/Recruitment/CandidateInterview/AddCandidateInterview/AddCandidateInterview";
import EditCandidateInterview from "HRMS/Recruitment/CandidateInterview/EditCandidateInterview/EditCandidateInterview";
import AddCandidateSelection from "HRMS/Recruitment/CandidateSelection/AddCandidateSelection/AddCandidateSelection";
import EditCandidateSelection from "HRMS/Recruitment/CandidateSelection/EditCandidateSelection/EditCandidateSelection";
import AddHoliday from "HRMS/Leave/Holiday/AddHoliday/AddHoliday";
import EditHoliday from "HRMS/Leave/Holiday/EditHoliday/EditHoliday";
import AddLeaveType from "HRMS/Leave/LeaveType/AddLeaveType/AddLeaveType";
import EditLeaveType from "HRMS/Leave/LeaveType/EditLeaveType/EditLeaveType";
import AddLeaveApplication from "HRMS/Leave/LeaveApplication/AddLeaveApplication/AddLeaveApplication";
import EditLeaveApplication from "HRMS/Leave/LeaveApplication/EditLeaveApplication/EditLeaveApplication";
import AddEmployee from "HRMS/Employee/AddEmployee/AddEmployee";
import EditEmployee from "HRMS/Employee/EditEmployee/EditEmployee";
import AddEmployeePerformance from "HRMS/EmployeePerformance/AddEmployeePerformance/AddEmployeePerformance";
import EditEmployeePerformance from "HRMS/EmployeePerformance/EditEmployeePerformance/EditEmployeePerformance";
import AddAward from "HRMS/Award/AddAward/AddAward";
import EditAward from "HRMS/Award/EditAward/EditAward";
import AddGrandLoan from "HRMS/Loan/GrandLoan/AddGrandLoan/AddGrandLoan";
import EditGrandLoan from "HRMS/Loan/GrandLoan/EditGrandLoan/EditGrandLoan";
import AddLoanInstallment from "HRMS/Loan/LoanInstallment/AddLoanInstallment/AddLoanInstallment";
import EditLoanInstallment from "HRMS/Loan/LoanInstallment/EditLoanInstallment/EditLoanInstallment";
import AddSalaryType from "HRMS/Payroll/SalaryType/AddSalaryType/AddSalaryType";
import EditSalaryType from "HRMS/Payroll/SalaryType/EditSalaryType/EditSalaryType";
import AddSalarySetup from "HRMS/Payroll/SalarySetup/AddSalarySetup/AddSalarySetup";
import EditSalarySetup from "HRMS/Payroll/SalarySetup/EditSalarySetup/EditSalarySetup";
import AddSalaryGenerate from "HRMS/Payroll/SalaryGenerate/AddSalaryGenerate/AddSalaryGenerate";
import EditSalaryGenerate from "HRMS/Payroll/SalaryGenerate/EditSalaryGenerate/EditSalaryGenerate";
import ViewEmployeeLoans from "HRMS/Loan/LoanReport/ViewEmployeeLoans/ViewEmployeeLoans";
import ViewInstallment from "HRMS/Loan/LoanReport/ViewEmployeeLoans/Components/ViewInstallment";
import EmployeeSalaryPaymentView from "HRMS/EmployeeSalaryPayment/EmployeeSalaryPaymentList/components/EmployeeSalaryPaymentView";
import AddAttendance from "HRMS/Attendance/AddAttendance/AddAttendance";
import EditAttendance from "HRMS/Attendance/EditAttendance/EditAttendance";

const HumanResourceRoutes = () => {
  const AddRoutesUrl = (url) => `/admin/:parent/${url}`;
  const EditRoutesUrl = (url) => `/admin/:parent/${url}/:id`;

  const CanCreateRoute = (path, element) => (
    <Route
      key={path}
      path={AddRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_create']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );

  const CanEditPageRoute = (path, element) => (
    <Route
      key={path}
      path={EditRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_edit']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );

  const CanViewPageRoute = (path, element) => (
    <Route
      key={path}
      path={EditRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_access']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );

  return [
    <Route key="profile" exact path="/admin/my-profile" element={<MyProfile />} />,
    CanCreateRoute("add-positions", <AddPositions />),
    CanEditPageRoute("edit-positions", <EditPositions />),
    CanCreateRoute("department-add", <AddDepartment />),
    CanEditPageRoute("department-edit", <EditDepartment />),
    CanCreateRoute("division-add", <AddDivision />),
    CanEditPageRoute("division-edit", <EditDivision />),
    CanCreateRoute("add-recruitment", <AddRecruitment />),
    CanEditPageRoute("edit-recruitment", <EditRecruitment />),
    CanCreateRoute("add-candidate-shortlist", <AddCandidateShortlist />),
    CanEditPageRoute("edit-candidate-shortlist", <EditCandidateShortlist />),
    CanCreateRoute("add-candidate-interview", <AddCandidateInterview />),
    CanEditPageRoute("edit-candidate-interview", <EditCandidateInterview />),
    CanCreateRoute("add-candidate-selection", <AddCandidateSelection />),
    CanEditPageRoute("edit-candidate-selection", <EditCandidateSelection />),
    CanCreateRoute("add-holiday", <AddHoliday />),
    CanEditPageRoute("edit-holiday", <EditHoliday />),
    CanCreateRoute("add-leave-type", <AddLeaveType />),
    CanEditPageRoute("edit-leave-type", <EditLeaveType />),
    CanCreateRoute("add-leave-application", <AddLeaveApplication />),
    CanEditPageRoute("edit-leave-application", <EditLeaveApplication />),
    CanCreateRoute("add-employee", <AddEmployee />),
    CanEditPageRoute("edit-employee", <EditEmployee />),
    CanCreateRoute("add-employee-performance", <AddEmployeePerformance />),
    CanEditPageRoute("edit-employee-performance", <EditEmployeePerformance />),
    CanCreateRoute("add-award", <AddAward />),
    CanEditPageRoute("edit-award", <EditAward />),
    CanCreateRoute("add-grand-loan", <AddGrandLoan />),
    CanEditPageRoute("edit-grand-loan", <EditGrandLoan />),
    CanCreateRoute("add-loan-installment", <AddLoanInstallment />),
    CanEditPageRoute("edit-loan-installment", <EditLoanInstallment />),
    CanCreateRoute("add-salary-type", <AddSalaryType />),
    CanEditPageRoute("edit-salary-type", <EditSalaryType />),
    CanCreateRoute("add-salary-setup", <AddSalarySetup />),
    CanEditPageRoute("edit-salary-setup", <EditSalarySetup />),
    CanCreateRoute("add-salary-generate", <AddSalaryGenerate />),
    CanEditPageRoute("edit-salary-generate", <EditSalaryGenerate />),
    CanViewPageRoute("view-employee", <ViewEmployeeLoans />),
    CanViewPageRoute("view-installment", <ViewInstallment />),
    CanViewPageRoute("view-employee-salary-payment", <EmployeeSalaryPaymentView />),
    CanCreateRoute("attendance-add", <AddAttendance />),
    CanEditPageRoute("attendance-edit", <EditAttendance />),
  ];
};


export default HumanResourceRoutes;
